<template>
    <section class="search">
        <button class="search__btn" type="button" @click="showSearch"
                :class="{_active: showSearchField}">
            <svg class="icon search__btn-icon">
                <use xlink:href="#search"/>
            </svg>
        </button>
        <div class="search__inner" v-show="showSearchField" :class="{_active: searchResultItems.length > 0}">
            <label class="input">
                <input ref="search" type="text" class="input__text search__input" placeholder="Поиск..." @keyup="search"
                       v-model="searchResults" @blur="test">
            </label>
        </div>
        <div v-if="searchResults" class="search__results">
            <ul class="search__results-list" v-if="searchResultItems.length > 0">
                <li class="search__results-item" v-for="searchResultItem of searchResultItems">
                    <a class="link search__results-link" :href="searchResultItem.link">{{ searchResultItem.name }}</a>
                </li>
            </ul>
            <p v-else>Извините, по вашему запросу ничего не найдено</p>
        </div>
        <overlay visible="false"></overlay>
    </section>
</template>

<script>
import overlay from './common/overlay'
export default {
    name: 'search',
    components: {overlay},
    data() {
        return {
            showSearchField: false,
            searchResults: null,
            searchResultItems: []
        }
    },
    methods: {
        showSearch() {
            this.showSearchField = true;
            this.$nextTick(() => this.$refs.search.focus())
        },
        test() {
            this.$nextTick(() => this.$refs.search.focus())
        },
        search() {
            this.$http.get('/api/search/'+this.searchResults).then(res => {
                this.searchResultItems = res.data;
            })
        }
    }
}
</script>
